import React from 'react';
import Header from "../Components/Header";
import DetailInfo from "./DetailInfo";
import SectionHeader from "../Components/SectionHeader";
import Prodcuts from "../Components/Products";
import Feature from "../Components/Feature";
import Footer from "../Components/Footer";
import detailBanner from "../assets/images/detailBanner.png"


export default function ProductDetail() {

  return (
    <>
    <Header mode="dark" />
    <DetailInfo />

    <div className="container-fluid mb-5">
      <img src={detailBanner} alt="" className='img-fluid'/>
    </div>
      <SectionHeader
          title="Related Products"
          subtitle="Discover premium fabrics, timeless designs, and comfort for every space."
      />
     <Prodcuts />


    
    <Feature />
    <Footer />
    </>



  );
}
